import { LayoutsResponse } from "../../@types";

export const getOption = (
  data?: LayoutsResponse,
  type?: string,
  id?: number
) => {
  if (!type || id === undefined || !data) return null;
  const item = data[type as keyof LayoutsResponse]?.find(
    value => value.id === id
  );

  if (!item) return null;

  return {
    type,
    value: item.id,
    label: item.name
  };
};

export const getOptions = (data?: LayoutsResponse) => {
  if (!data) return [];
  return [
    {
      label: "Personal Layouts",
      options:
        data.user.map(item => ({
          value: item.id,
          label: item.name,
          type: "user"
        })) ?? []
    },
    {
      label: "Team Layouts",
      options:
        data.shared.map(item => ({
          value: item.id,
          label: item.name,
          type: "shared"
        })) ?? []
    },
    {
      label: "RL Layouts",
      options:
        data.rl.map(item => ({
          value: item.id,
          label: item.name,
          type: "rl"
        })) ?? []
    }
  ];
};
